module.exports = __webpack_public_path__ + "static/media/RC.b8e00e50.jpg";